<template>
    <div class="ts-finder__canton-filter">
        <button ref="cantonFilterToggle" @click="toggleKantone" class="ts-finder__canton-filter-list-toggle">{{strings['TsFinder.Map.Cantons']}}<div class="ts-finder__canton-filter-list-toggle-icon"><i class="fas fa-angle-down"></i></div></button>
        <div ref="cantonFilterWrapper" style="display:none">
            <ul class="ts-finder__canton-filter-list ts-finder__canton-filter-list--level-1">
                <li v-for="(filter, index) in serverCantonFilters" :key="index" class="ts-finder__canton-filter-list-item ts-finder__canton-filter-item--level-1">
                    <CantonCheckbox :name="filter.name" :filter="filter.filter" :level="1" />
                    <ul class="ts-finder__canton-filter-list ts-finder__canton-filter-list--level-2" v-if="filter.children">
                        <li v-for="(child, index) in filter.children" :key="index" class="ts-finder__canton-filter-list-item ts-finder__canton-filter-item--level-2">
                            <CantonCheckbox :name="child.name" :filter="child.filter" :level="2" />
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import CantonCheckbox from './CantonCheckbox.vue';
    import { mapState } from 'vuex'
    import $ from 'jQuery'

    export default {
        computed: {
            ...mapState([
                'serverCantonFilters',
                'strings'
            ])
        },
        components: {
            CantonCheckbox
        },
        methods: {
            toggleKantone() {
                $(this.$refs.cantonFilterToggle).toggleClass('active');
                $(this.$refs.cantonFilterWrapper).slideToggle();
            }
        }
    };
</script>